import React from "react";
import * as Icons from 'react-bootstrap-icons';
import Translator from "Languages/Utility/Translator";
import { useSelector } from "react-redux";

export default function SelectedUnitCount() {
    const { factorResult, factorPagination } = useSelector((state) => ({
        factorResult: state.factor.factorResult,
        factorPagination: state.factor.factorPagination,
    }));
    return (
        <div className="d-flex flex-row flex-nowrap">
            <Icons.CardList size={20} className="mx-2"/>
            <p className="m-0">
                <Translator id='selectedUnitCount' />
                {" : "}
                <strong>{factorResult.CheckAll ? factorPagination.Total : factorResult.ListUnitId.length}</strong>
                {" "}
                <Translator id='units' />
            </p>
        </div>
    );
};